/*
This file is to aggregate some of the messy Onboarding Standalone utils.
When this feature gets deprecated or revisited, hopefully it'll be easier to
remove or edit, having much of the logic in one place.
*/
/* eslint-disable no-unused-expressions */
import * as track from '../../track/track'
import * as URLS from '../../urls'
import {OnboardingStepNames} from '../../store/enum'

export const isCurrentPageOnboardingStandalone = () =>
  window?.location?.pathname === URLS.ONBOARDING

export const redirectUrlPath = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  let url = new URL(window.location.origin)
  // If there's a redirect param, pass along all other params with it
  if (params.redirect) {
    url = new URL(params.redirect)
    params['selected-items'] && url.searchParams.append('selected-items', params['selected-items'])
    params['for-groups'] && url.searchParams.append('for-groups', params['for-groups'])
    params.category && url.searchParams.append('category', params.category)
    params.color && url.searchParams.append('color', params.color)
  }
  return url
}

export const completedOnboardingRedirectUrl = () => {
  const url = redirectUrlPath()
  url.searchParams.append('completedOnboarding', true)
  return url.toString()
}

export const onboardingStandaloneOnClose = (currentStep, isLoggedIn, hasEventDetails) => {
  const hasCompletedOnboarding = isLoggedIn && hasEventDetails
  const redirectUrl = hasCompletedOnboarding
    ? completedOnboardingRedirectUrl()
    : redirectUrlPath().toString()

  track.onboardingClosed(OnboardingStepNames[currentStep])

  window.location.href = redirectUrl || URLS.HOME
}

export const getLoginRedirectPath = (origin) => {
  const url = new URL(window.location.origin)
  const originPath = origin || window.location.href
  url.port = window.TBT_ENV === 'local' ? '3040' : ''
  url.searchParams.append('isLogin', true)
  url.searchParams.append('origin', originPath)

  return url.href
}
/* eslint-enable no-unused-expressions */
